import { CREADIT_OR_DEBIT } from './components/add-ach-modal/constant'

export const TRANSACTION_EXCEPTION_TYPE = {
  EXCEPTION: 'exception',
  PAID: 'paid',
}

export const EXCEPTION_TYPE = {
  ALL: 0,
  ACH: 1,
  CHECK: 2,
}

export const exampleTransactionException = {
  exceptionType: 'UACHT',
  amount: '$4,017.25',
  exceptionStatus: 'Exception',
  defaultDecision: 'Return',
  exceptionDate: '06/17/2024',
  decisionDueDate: '06/17/2024 11:30 AM Pacific Time (US & Canada)',
  cutOffTime: '11:30 AM Pacific Time (US & Canada)',
  accountName: 'Damien L. Stanton',
  paidDate: '06/17/2024',
  secCode: 'PPD',
  achOriginatorId: '2332',
  debitCredit: 'Debit',
  transactionDescription: 'Payroll',
  determinedFromTransCode: '23',
}

export const exampleTransactionPaid = {
  exceptionType: 'UACHT',
  amount: '$3,313.25',
  exceptionStatus: 'Exception',
  decision: 'Return',
  exceptionDate: '06/17/2024',
  reason: 'N/A',
  decisionBy: 'John Doe',
  decisionTime: '06/17/2024 11:30 AM Pacific Time (US & Canada)',
  accountName: 'OPERATING ACCOUNT',
  paidDate: '06/17/2024',
  secCode: 'PPD',
  achOriginatorId: '2332',
  debitCredit: 'Debit',
  transactionDescription: 'Payroll',
  determinedFromTransCode: '23',
}

export const exampleACHData = {
  clientNames: 'c477e74c-bf89-452b-b573-099a8b1196c2',
  accountNames: ['dd8d292f-eb49-40f6-9e15-08dca4bbbaef'],
  achOriginatorId: 2332,
  secCode: ['9dc2de1a-2945-481f-9c6a-05d043e97951'],
  creditOrDebit: CREADIT_OR_DEBIT.DEBIT,
  amount: '4017.25',
}

export const EXCEPTION_DETAIL_DEFAULT = {
  id: '',
  type: ''
}
